// src/api/couponAdminApi.ts

import client from "./client";
import {
  AdminCoupon,
  ApiResponse,
  CouponRequest,
  CouponStatus,
  UserCoupon,
  PageResponse,
} from "../types";

export interface CouponFilters {
  search?: string;
  status?: CouponStatus | "";
  page?: number;
  size?: number;
}

export const couponAdminApi = {
  listar: ({ search, status, page = 0, size = 20 }: CouponFilters) =>
    client
      .get<ApiResponse<PageResponse<AdminCoupon>>>("/admin/coupons", {
        params: {
          search: search?.trim() || undefined,
          status: status || undefined,
          page,
          size,
        },
      })
      .then((r) => r.data),

  /** Cupones vigentes, con usos disponibles y del 100% (los que se pueden asignar a un usuario). */
  asignables: () =>
    client.get<ApiResponse<AdminCoupon[]>>("/admin/coupons/assignable").then((r) => r.data),

  crear: (payload: CouponRequest) =>
    client.post<ApiResponse<AdminCoupon>>("/admin/coupons", payload).then((r) => r.data),

  actualizar: (id: string, payload: CouponRequest) =>
    client.put<ApiResponse<AdminCoupon>>(`/admin/coupons/${id}`, payload).then((r) => r.data),

  cambiarEstado: (id: string, active: boolean) =>
    client
      .patch<ApiResponse<AdminCoupon>>(`/admin/coupons/${id}/active`, { active })
      .then((r) => r.data),

  usos: (id: string) =>
    client.get<ApiResponse<UserCoupon[]>>(`/admin/coupons/${id}/usages`).then((r) => r.data),
};
